import {Alert, Button, Code, Group, Stack, Text} from '@mantine/core';
import {AiOutlineCheckCircle, AiOutlineCloseCircle} from 'react-icons/ai';
import {FlowResult} from '../types';

interface FlowResultDisplayProps {
    result: FlowResult;
    onReset: () => void;
}

export const FlowResultDisplay = ({result, onReset}: FlowResultDisplayProps) => {
    return (
        <Stack gap="md">
            <Alert
                icon={result.success ? <AiOutlineCheckCircle size={24}/> : <AiOutlineCloseCircle size={24}/>}
                title={result.success ? 'Flow Completed Successfully' : 'Flow Failed'}
                color={result.success ? 'teal' : 'red'}
            >
                {result.success ? (
                    <Stack gap="xs">
                        {result.status && <Text size="sm">Status: <Code>{result.status}</Code></Text>}
                        {result.intentId && <Text size="sm">Intent ID: <Code>{result.intentId}</Code></Text>}
                        {result.paymentMethodId &&
                            <Text size="sm">Payment Method: <Code>{result.paymentMethodId}</Code></Text>}
                        {result.subscriptionId &&
                            <Text size="sm">Subscription: <Code>{result.subscriptionId}</Code></Text>}
                    </Stack>
                ) : (
                    <Text size="sm">{result.error}</Text>
                )}
            </Alert>

            <Group>
                <Button variant="light" onClick={onReset}>Start Over</Button>
            </Group>
        </Stack>
    );
};
